import { createAlert } from "actions/alerts";
import { closeModal } from "actions/modal";
import keyConverter from "services/key-converter";

/**
 * If there are errors during the action, add them to the modalProps to be displayed
 * in the modal
 * @param {Object} args
 * @returns {Function}
 */
function handleBulkAddErrors(args) {
  const { errors } = args.response.data;

  return (dispatch, getState) => {
    const { modalProps } = getState().modal;
    dispatch({
      type: "SET_MODAL",
      payload: {
        isOpen: true,
        view: "MODAL_BULK_TRAINING",
        modalProps: modalProps.merge({
          errors: keyConverter(errors, "camel")
        })
      }
    });
  };
}

/**
 * @param {Immutable.Record} response
 * @param {Immutable.List} trainingData
 * @returns {Function}
 */
export function handleAddBulkTrainingAction(response, trainingData) {
  const operations = trainingData.map(body => ({
    "body": body,
    "responseId": response.id
  }));

  const payload = keyConverter({
    operationType: "batch_create",
    operations
  }, "underscore");

  const successMessage = `Training has been added to ${response.handle}`;

  return {
    CALL_API: {
      method: "post",
      endpoint: "/expressions/rpc/modify_expressions",
      payload,
      types: [
        "CREATE_EXPRESSIONS_REQUEST",
        "CREATE_EXPRESSIONS_SUCCESS",
        "CREATE_EXPRESSIONS_FAILURE"
      ],
      dispatchCallbacks: [
        {
          request: createAlert,
          fireOnStatus: 400,
          args: {
            message: "Sorry, your request could not be completed.",
            alertType: "error"
          }
        },
        {
          request: createAlert,
          fireOnStatus: 409,
          args: {
            message: "Sorry, one (or more) of those questions already exists on other answers.",
            alertType: "warning"
          }
        },
        {
          request: handleBulkAddErrors,
          fireOnStatus: 409
        },
        {
          request: createAlert,
          fireOnStatus: 200,
          args: {
            message: successMessage,
            alertType: "success"
          }
        },
        {
          request: closeModal,
          fireOnStatus: 200
        },
        {
          request: createAlert,
          fireOnStatus: 207,
          args: {
            message: "Sorry, one (or more) of those questions could not be trained.",
            alertType: "warning"
          }
        },
        {
          request: handleBulkAddErrors,
          fireOnStatus: 207
        }
      ]
    }
  };
}
